import { GET_JOB_BY_ID } from '../../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case GET_JOB_BY_ID.LOAD:
      return {
        ...state,
        loading: true,
      };
    case GET_JOB_BY_ID.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case GET_JOB_BY_ID.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
